var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['c-button', 'text-ibm-plex-sans', _vm.color, _vm.type],attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.$t(_vm.label))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }